import { BaseEntity } from '../../../models';
import { Area } from '../../areas';
import { Cidade } from '../../cidade/cidade';
import { Cliente } from '../../pessoa/cliente/cliente';
import { PacoteCampanha } from '../pacotes/pacote-campanha';
import { CampanhaCliente } from './promocao/clientes';
import { CampanhaRecurso } from './recursos';
import { CampanhaRepresentante } from './representantes';
import { CampanhaResultado } from './resultado';
import { CampanhaTabelaPreco } from './tabelas-precos';
import { CampanhaStatus, campanhaStatusEmAndamento, campanhaStatusNaoConfirmada } from './status';
import { ArquivoUpload } from '../../arquivos/arquivos/upload';

export class Campanha implements BaseEntity {
    id: number;
    createdAt: Date;
    idUsuarioCreated: number;
    updatedAt: Date;
    idUsuarioUpdated: number;
    idEmpresa: number;

    // Configuração
    numero: number;
    idArea: number;
    area: Area;
    status: number;
    nome: string;
    descricao: string;

    // -- Pacote -- //
    idPacoteCampanha: number;
    pacoteCampanha: PacoteCampanha;
    // Objetivo Venda
    objetivoVenda: boolean;
    // Objetivo Bonificação
    objetivoBonificacao: boolean;
    codigoIntegracaoErpCentroCusto: string;
    codigoIntegracaoErpPlanoConta: string;
    obrigarPedidoVenda: boolean;
    percLimiteBonificacao: number;
    // Objetivo Aquisição
    objetivoAquisicao: boolean;

    // Vigência
    vigenciaRecorrente: boolean;
    quantidadeDiasVigencia: number;
    dataTerminoVigencia: Date;

    // Configurações Avançadas
    idCliente: number;
    cliente: Cliente;
    idCidade: number;
    cidade: Cidade;
    landingPageURL: string;
    permitirCadastrarLeadSemCnpjCpf: boolean;
    tabelasPrecos: CampanhaTabelaPreco[];
    quantidadeTabelasPrecos: number;
    /**Cupons utilizados para associar dinamicamente as campanhas, podendo ser, cupons de descontos, brindes, frete grátis, cashback, etc. */
    cupons: string[];

    // Resultado
    resultado: CampanhaResultado;

    // Recursos
    orcamentoDisponivel: number;
    recursos: CampanhaRecurso[];

    // ROI Esperado
    roiEsperadoPercLeadsQualificados: number;
    roiEsperadoPercOportunidadesGanhas: number;
    roiEsperadoValor: number;
    roiEsperadoPerc: number;

    // ROI
    roiPontoEquilibrio: number;

	// Análise
    dataSolicitacaoAnalise: Date;
    idUsuarioSolicitacaoAnalise: number;
    dataAnalise: Date;
    idUsuarioAnalise: number;
    justificativaAnalise: string;

    // Em Andamento
    dataInicioAndamento: Date;
    idUsuarioInicioAndamento: number;
    dataTerminoAndamento: Date;
    idUsuarioTerminoAndamento: number;

    // Encerramento
    dataEncerramento: Date;
    idUsuarioEncerramento: string;

    // Acessos
    representantes: CampanhaRepresentante[];

    // Promoção
    tipoPromocao: number;
    clientes: CampanhaCliente[];

    // Arquivos
    arquivosUpload: ArquivoUpload[];

    constructor(status: CampanhaStatus = campanhaStatusNaoConfirmada) {
        this.status = status ? status.id : campanhaStatusNaoConfirmada.id;
        this.recursos = [];
        this.representantes = [];
        this.clientes = [];
        this.tabelasPrecos = [];
        this.arquivosUpload = [];
        this.cupons = [];
    }
}

/** Cria uma campanha "SEM CAMPANHA" para apresentar dados de recursos e resultados sem campanhas vinculadas */
export function createSemCampanha(): Campanha {
    const semCampanha = new Campanha(campanhaStatusEmAndamento);
    semCampanha.id = -1;
    semCampanha.nome = 'SEM CAMPANHA';
    return semCampanha;
}
